// @flow

import React from 'react';
import StyledButton from './button.styled';
import Link from '../link';
import type { ButtonProps, LinkButtonProps, FakeButtonProps } from './types';

const LinkButton = (props: LinkButtonProps) => (
  <StyledButton as={Link} {...props} />
);

const AnchorButton = (props: LinkButtonProps) => (
  <StyledButton as="a" {...props} />
);

const FakeButton = (props: FakeButtonProps) => (
  <StyledButton as="div" {...props} />
);

const Button = ({
  caret,
  children,
  className,
  collapsed,
  collapsible,
  colors,
  disabled,
  fullWidth,
  hasMargin,
  href,
  onClick,
  position,
  rounded,
  size,
  variant,
  withIcon,
  type,
}: ButtonProps) => {
  if (href) {
    if (href.charAt(0) === '#') {
      return (
        <AnchorButton
          caret={caret}
          className={className}
          collapsed={collapsed}
          collapsible={collapsible}
          colors={colors}
          disabled={disabled}
          fullWidth={fullWidth}
          hasMargin={hasMargin}
          href={href}
          onClick={onClick}
          position={position}
          rounded={rounded}
          size={size}
          variant={variant}
          withIcon={withIcon}
          type={type}
        >
          {children}
        </AnchorButton>
      );
    }
    return (
      <LinkButton
        caret={caret}
        className={className}
        collapsed={collapsed}
        collapsible={collapsible}
        colors={colors}
        disabled={disabled}
        fullWidth={fullWidth}
        hasMargin={hasMargin}
        href={href}
        onClick={onClick}
        position={position}
        rounded={rounded}
        size={size}
        variant={variant}
        withIcon={withIcon}
        type={type}
      >
        {children}
      </LinkButton>
    );
  }

  return (
    <StyledButton
      caret={caret}
      className={className}
      collapsed={collapsed}
      collapsible={collapsible}
      colors={colors}
      disabled={disabled}
      fullWidth={fullWidth}
      hasMargin={hasMargin}
      onClick={onClick}
      position={position}
      rounded={rounded}
      size={size}
      type={type}
      variant={variant}
      withIcon={withIcon}
    >
      {children}
    </StyledButton>
  );
};

const defaultProps = {
  caret: false,
  className: '',
  collapsed: false,
  collapsible: false,
  colors: 'default',
  disabled: false,
  fullWidth: false,
  hasMargin: true,
  href: '',
  onClick: null,
  position: 'center',
  rounded: false,
  size: 'default',
  type: null,
  variant: 'default',
  withIcon: false,
};

Button.defaultProps = defaultProps;
LinkButton.defaultProps = defaultProps;
FakeButton.defaultProps = defaultProps;

export {
  FakeButton,
  LinkButton,
};

export default Button;
